import React, {useEffect} from "react";
import "../CoursePage.sass";

export default function PrepareSchool() {
    useEffect(() => {
        document.title = 'КьюАй - Подготовка к школе';
    }, [])

    return <>
        <div>
            Курс Подготовка к школе является образовательной программой, которая предназначена для подготовки
            детей к началу школы и обеспечения их успешного вхождения в школьный мир. Наш курс поможет деткам
            научиться чтению и письму, развить фонематический слух, математические способности, память и
            внимание, а также логику и мышление. Мы предлагаем индивидуальный подход к обучению и качественный
            материал, преподаваемый профессиональными преподавателями. Все это сделает подготовку к школе
            веселым и интересным процессом для ребят.
        </div>
        <div className="course-footer-second">
            <div className="course-footer-second-ul">
                <div className="course-footer-second-ul-title">
                    Что получит ребёнок?
                </div>
                <ul>
                    <li>Обучение чтению и письму;</li>
                    <li>Развитие фонематического слуха;</li>
                    <li>Обучение грамоте;</li>
                    <li>Освоение слогов, слов и проведение звукобуквенного анализа;</li>
                    <li>Изучение цифр, различных видов счета и математических закономерности;</li>
                    <li>Совершенствование навыков памяти и внимания;</li>
                    <li>Развитие логики и мышления;</li>
                    <li>Формирование навыков анализа, рассуждения и аргументации своего мнения.</li>
                </ul>
            </div>
            <div className="course-footer-second-img">
                <div className="course-footer-second-psh"></div>
            </div>
        </div>
        <div>
            Школа КьюАй предлагает уникальный курс Подготовка к школе, который обеспечивает индивидуальный и
            групповой подход к обучению. Во время занятий, преподаватели регулярно меняют форму деятельности,
            чтобы усилить восприятие информации учениками. Наши высококвалифицированные преподаватели помогают
            ребятам развить самостоятельность и желание получать новые знания.Все занятия в цифровом формате с
            раздаточным материалом, что позволяет заинтересовать ребят и усилить тягу к знаниям.
        </div>
        <div>
            Родители, не упустите шанс подготовить вашего ребенка к учебному году с помощью курса Подготовка к
            школе в центре детского развития КьюАй. Наши опытные педагоги помогут ребенку сформировать навыки,
            необходимые для успешного обучения в школе, а также наладить режим учебы и развить мотивацию.
            Запишите своего ребенка на курс прямо сейчас!
        </div>
    </>
}